import { Fragment, useState } from 'react'
import { Theme, Color } from '@opallabs/gem'
import { DefaultQueryClientProvider } from '@opallabs/higgs'
import { ThemeProvider } from '@opallabs/hooks'
import { Button, Icon } from '@opallabs/lapidary'
import { EmojiPopover, EmojiPopoverProps } from './EmojiPopover'
import type { Emoji } from './EmojiPopover/EmojiPopoverContent'
import * as styles from './styles'

type EmojiPickerProps = Omit<EmojiPopoverProps, 'openPopover'> & {
  theme: Theme
}

export const EmojiPicker: React.FC<EmojiPickerProps> = ({
  theme,
  isReaction,
  onSelect,
}) => {
  const [openPopover, setOpenPopover] = useState(false)
  const onSelectEmoji = (emoji: Emoji) => {
    setOpenPopover(false)
    onSelect(emoji)
  }
  return (
    <DefaultQueryClientProvider>
      <ThemeProvider theme={theme}>
        <EmojiPopover
          isReaction={isReaction}
          onSelect={onSelectEmoji}
          openPopover={openPopover}
          setOpenPopover={setOpenPopover}
        >
          {isReaction ? (
            <Button
              theme="light"
              onClick={() => setOpenPopover(true)}
              name="Choose emoji"
              styleOverrides={{ button: styles.reactionButtonOverrides }}
              icon={
                <Fragment>
                  <Icon
                    glyph="emoji-in-chat"
                    useHypernova
                    color={Color.dark.Text.Gray}
                    height={14}
                    width={12}
                  />
                  <Icon
                    glyph="gem-add"
                    color={Color.dark.Text.Gray}
                    height={14}
                    width={10}
                  />
                </Fragment>
              }
              variant="tertiary"
            />
          ) : (
            <Button
              theme="dark"
              onClick={() => setOpenPopover(true)}
              name="Choose emoji"
              styleOverrides={{ button: styles.emojiInputButtonOverrides }}
              icon={
                <Icon
                  glyph="emoji-in-chat"
                  useHypernova
                  color={Color.dark.Text.Default}
                />
              }
              variant="ghost"
            />
          )}
        </EmojiPopover>
      </ThemeProvider>
    </DefaultQueryClientProvider>
  )
}
